import Vue from "vue";
import view from "view-design";
import wx from "weixin-js-sdk";
import axios from "axios";

// 判断当前设备PC/移动
let ispc = function ispc() {
  // return !/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent);
  var ua = navigator.userAgent;
  var isMidp = ua.match(/midp/i) == "midp";
  var isUc7 = ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var isUc = ua.match(/ucweb/i) == "ucweb";
  var isAndroid = ua.match(/android/i) == "android";
  var isCE = ua.match(/windows ce/i) == "windows ce";
  var isWM = ua.match(/windows mobile/i) == "windows mobile";
  let isIphone = ua.indexOf("iPhone") != -1;
  let isIPad = !isIphone && "ontouchend" in document;
  if (
    isIPad ||
    isIphone ||
    isMidp ||
    isUc7 ||
    isUc ||
    isAndroid ||
    isCE ||
    isWM
  ) {
    return false;
  } else {
    return true;
  }
};

let global = {
  // 判断当前设备PC/移动
  ispc: ispc(),
  ddUplodeUrl: "http://localhost:8292/zw-public/uploader/nf/", // 断电续传路径
  url2: "/zw-public/web/common/upload", // 富文本上传图片/视频地址
  url: process.env.VUE_APP_API_BASE_URL, // 接口基地址
  url1: process.env.VUE_APP_CNK_H5_URL, // 二维码需要地址
  imgUrl: process.env.VUE_APP_IMG_BASE_URL, // 图片路径基地址
  uplodeUrl: process.env.VUE_APP_API_BASE_URL, // 上传接口
  baijiaUrl: process.env.VUE_APP_BAIJIA_URL, // 百家在线网址
  baikeUrl: process.env.VUE_APP_BAIKE_URL, // 百科网址
  zhifu: process.env.VUE_APP_BAIJIA_URL, // 微信支付判断
  SeoUrl: process.env.VUE_APP_CNK_PC_URL, // seo跳转静态页面路径 首页,论文详情
  tsgUrl: process.env.VUE_APP_TSG_URL,
  editCardUrl: process.env.VUE_APP_CBMP_URL,
  meetingUrl: process.env.VUE_APP_MEETING_PC_URL,
  meetingH5Url: process.env.VUE_APP_MEETING_H5_URL,
  

  //获取url参数
  getQueryVariable(variable) {
    let query = decodeURI(window.location.search.substring(1));
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },
  //行文问题
  belowOne(num) {
    let data = [
      {
        name: "多字、少字、错别字",
      },
      {
        name: "病句（用词不当、语句杂糅等）",
      },
      {
        name: "语言不规范，口语化严重、网络语言过多等",
      },
      {
        name: "敏感词汇过多，如脏话、淫秽语言等",
      },
      {
        name: "存在法律法规禁用词汇",
      },
      {
        name: "文章主线不明确",
      },
      {
        name: "逻辑不通，前后矛盾或不一致",
      },
      {
        name: "文章内容重复冗长",
      },
      {
        name: "篇幅过短，价值过低",
      },
    ];
    if (num == "") {
      return;
    }
    return data[num - 1].name;
  },
  //格式问题
  belowTwo(num) {
    let data = [
      {
        name: "首行缩进不规范",
      },
      {
        name: "行间距、段间距不规范",
      },
      {
        name: "前后格式不一致",
      },
      {
        name: "空格、换行、标点等使用不当",
      },
      {
        name: "存在法律法规禁用词汇",
      },
      {
        name: "字体不统一",
      },
    ];
    if (num == "") {
      return;
    }
    return data[num - 1].name;
  },
  //其他问题
  belowThree(num) {
    let data = [
      {
        name: "内容夸大，过于浮夸",
      },
      {
        name: "负能量过多，批判性过强",
      },
      {
        name: "商业性质太强（平台推广除外）",
      },
      {
        name: "文章抄袭、洗稿",
      },
      {
        name: "信息不准确（错误、过时、未经验证等）",
      },
      {
        name: "来源不明",
      },
    ];
    if (num == "") {
      return;
    }
    return data[num - 1].name;
  },
  checkPhone(value) {
    //验证手机号
    if (value == "") {
      view.Message.warning("手机号不能为空");
      return false;
    }
    if (!/^1[3456789]\d{9}$/.test(value)) {
      view.Message.warning("手机号格式不对");
      return false;
    }
    return true;
  },
  //升序
  sortKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },
  transferDate(times) {
    //时间戳转时间
    var date = new Date(Number(times));
    var Y = date.getFullYear() + "-";
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + "-";
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  },
  transferDay(times, mark = "-") {
    //时间戳转时间
    var date = new Date(Number(times));
    var Y = date.getFullYear() + mark;
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + mark;
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return Y + M + D;
  },
  transferMonth(times) {
    //时间戳转时间年月
    var date = new Date(Number(times));
    var Y = date.getFullYear() + "-";
    var M =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    return Y + M;
  },
  transferTime(times) {
    //时间转时间戳
    return new Date(times).getTime();
  },
  /*
    formatDateWithZh
    格式化日期时间为带有中文标识的日期格式 
    params:dateStr 必填 日期字符串 "2023-07-14 00:00:00"
    params:needMinutesSeconds 选填 是否需要时分 如 2023年7月1日 9:00
  */
  formatDateWithZh(dateStr, needHms) {
    var date = new Date(dateStr);
    var Y = date.getFullYear() + "年";
    var M = date.getMonth() + 1 + "月";
    var D =
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日 ";

    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      ":";
    var s =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    return needHms ? Y + M + D + h + m + s : Y + M + D;
  },
  /*
  日期字符串 "2023-07-14 00:00:00"
  日期格式转化为：年月日时分
  */
  formatDateWithZhToYMDHM(dateStr) {
    var date = new Date(dateStr);
    var Y = date.getFullYear() + "年";
    var M = date.getMonth() + 1 + "月";
    var D =
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日 ";

    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    return Y + M + D + h + m;
  },
  /*
  日期字符串 "2023-07-14 00:00:00"
  日期格式转化为：年月日时分
  */
  formatDateWithZhToYMD(dateStr) {
    var date = new Date(dateStr);
    var Y = date.getFullYear() + "年";
    var M = date.getMonth() + 1 + "月";
    var D =
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日 ";

    var h =
      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
    var m =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    return Y + M + D;
  },
  // 日期字符串 '2023-07-14 00：00：00'  转为2023.07.14
  formatDateDrop(dateStr) {
    var date = new Date(dateStr);
    var Y = date.getFullYear() + ".";
    var M = date.getMonth() + 1 + ".";
    var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    return Y + M + D;
  },
  /*
  日期字符串 "2023-07-14 00:00:00"
  日期格式转化为：年月
  */
  formatDateWithZhToYM(dateStr) {
    var date = new Date(dateStr);
    console.log("formatDateWithZhToYM", date);
    var Y = date.getFullYear() + "-";
    var M = date.getMonth() + 1;
    M = M < 10 ? "0" + M : M;

    return Y + M;
  },

  copyArr(arr) {
    //拷贝数组
    return JSON.parse(JSON.stringify(arr));
    // return Object.assign([], arr)
  },
  copyObj(obj) {
    //拷贝对象
    return Object.assign({}, obj);
  },
  getGradeName(gradeId) {
    if (gradeId == 7) {
      return "初一";
    }
    if (gradeId == 8) {
      return "初二";
    }
    if (gradeId == 9) {
      return "初三";
    }
  },
  sortByKey(array, key) {
    //(数组、排序的列)
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  },
  // 移动端判断安卓is苹果
  isAndroid_ios() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //安卓
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      return true;
    } else if (isIOS) {
      return false;
    }
  },
  deepClone(obj) {
    let cloneObj = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
      for (const key in obj) {
        if (key === "timeArr") {
          console.log(obj[key]);
        }
        if (obj.hasOwnProperty(key)) {
          if (obj[key] && typeof obj[key] === "object") {
            cloneObj[key] = this.deepClone(obj[key]);
          } else {
            cloneObj[key] = obj[key];
          }
        }
      }
    }
    return cloneObj;
  },
  // 去掉所有html标签然后再标签栏展示
  matchReg(text) {
    //1.首先动态创建一个容器标签元素，如DIV
    var temp = document.createElement("div");
    //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
    temp.innerHTML = text;
    //3.最后返回这个元素的innerText或者textContent，即得到经过HTML解码的字符串了。
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
  },
  toShare(title, artSummary, cover) {
    axios
      .post(
        `/zw-wechat/wx/nf/getSignature`,
        { url: location.href },
        {
          headers: {
            rsa: "no",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log(response, "res");
        wx.config({
          // debug: true,
          appId: response.data.data.appId,
          timestamp: response.data.data.timestamp,
          nonceStr: response.data.data.nonceStr,
          signature: response.data.data.signature,
          jsApiList: ["updateAppMessageShareData"],
        });
        wx.ready(function () {
          console.log(1111);
          // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData({
            title: global.matchReg(title) + " - 中文知识网", // 分享标题 期刊名-采编名
            desc: global.matchReg(artSummary), // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: cover ? `${global.imgUrl}${cover}` : "", // 分享图标
            success: function () {
              console.log("成功");
              // 设置成功
              // alert("成功");
            },
            cancel: function () {
              console.log("失败");
              // 用户取消分享后执行的回调函数
              // alert("失败");
            },
          });
        });
        wx.error(function (res) {
          console.log("微信分享错误信息", res);
        });
      });
  },
  // 商品数据转换vant-sku数据格式
  formatGoodsDataToVantSku(
    { goods, goodsList, goodsSkuInfosDto, shopsInfoDto },
    minPrice,
    maxPrice
  ) {
    var goodsObj = {
      sku: {
        tree: [],
        list: [],
        price: "", // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        collection_id: null, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品

        hide_stock: true, // 是否隐藏剩余库存
      },
      initialSku: {
        s1: "",
        s2: "",
        // 初始选中数量
        selectedNum: 1,
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: "",
      },
    };
    console.log(goods, goodsList, goodsSkuInfosDto, shopsInfoDto);
    goodsObj.sku.price =
      minPrice === maxPrice ? minPrice : `${minPrice}-${maxPrice}`;

    // sku:{tree:[{k:specifitionvalue,k_id:specificationTypeId,v:[{id:typeValuesId,name:specTypeValue,imgUrl:typeValue.logo}]}]}
    if (goodsSkuInfosDto.specificationsTypeValuesDtos.length) {
      // 有规格商品
      var tree = [];
      goodsSkuInfosDto.specificationsTypeValuesDtos.forEach(
        (typeInfo, index) => {
          console.log(typeInfo);
          var specValues = [];
          typeInfo.specificationsTypeValues.forEach((specValue) => {
            // 有的图片有前缀,有的没有
            let imgUrl = null;
            if (specValue.logo) {
              if (specValue.logo.indexOf("http") !== -1) {
                imgUrl = specValue.logo;
              } else {
                imgUrl = global.imgUrl + specValue.logo;
              }
            }
            specValues.push({
              // 规格值id
              id: specValue.id,

              name: specValue.specificationsValue,
              imgUrl: specValue.logo != "" ? imgUrl : "",
            });
            console.log(specValue);
          });
          tree.push({
            k_id: typeInfo.specificationsTypeId,
            k_s: `s${index + 1}`,
            // 规格类型名
            k: typeInfo.specificationsTypeName,
            v: specValues,
          });
        }
      );
      console.log("tree", tree);
      // 格式化所有sku的商品组合列表 vant/sku商品价格以分为单位
      var list = [];
      goodsSkuInfosDto.list.forEach((skuItem) => {
        var item = {
          // 规格id(同上)
          id: skuItem.id,
          // 商品id
          goodsId: skuItem.goodsId,
          // 自定义字段 价格(元为单位)
          skuPrice: skuItem.skuPrice,
          // 商品图片
          // memberIcon: skuItem.memberIcon,
          // vant-sku 默认字段 展示以分为单位价格（元为单位）
          price:
            skuItem.indicativePrice || skuItem.indicativePrice == 0
              ? skuItem.indicativePrice * 100
              : skuItem.skuPrice * 100,
          // 规格值Id (暂时使用值匹配)
          s1: skuItem.specificationsValueOneId,
          s2: skuItem.specificationsValueTwoId,
          // 最多包含3个规格值，为0表示不存在该规格
          s3: "0",
          stock_num: skuItem.skuStock,
          // 商品id
          goods_id: skuItem.goodsId,
          desc: skuItem.skuDesc,
        };
        // 自定义字段，当前规格是否需要审核（会议有审核字段）
        if (skuItem.hasOwnProperty("isExamine")) {
          item.isExamine = skuItem.isExamine;
        }
        // 自定义字段，当前规格是否需要投稿（会议有审核字段）
        if (skuItem.hasOwnProperty("isSubmitThesis")) {
          item.isSubmitThesis = skuItem.isSubmitThesis;
        }
        list.push(item);
      });
      // 获取第一个库存不为0的商品数据作为初始化选中规格数据，如果所有库存都为0 ，则不设置初始化规格数据
      var initialItemIndex = list.findIndex((item) => {
        return item.stock_num != 0;
      });
      if (initialItemIndex != -1) {
        // 初始化规格项
        goodsObj.initialSku = {
          s1: list[initialItemIndex].s1,
          s2: list[initialItemIndex].s2,
          selectedNum: 1,
        };
      } else {
        // 所有规格都为0，不设置初始规格项
        goodsObj.initialSku = {
          s1: "0",
          s2: "0",
          selectedNum: 0,
        };
      }
      goodsObj.sku.tree = tree;
      goodsObj.sku.list = list;
    } else {
      var skuItem = goodsSkuInfosDto.list[0];
      goodsObj.sku.tree = [
        {
          // 规格类目名称为空 名称
          k: "",
          k_s: "s1",
          v: [
            {
              //
              id: "1",
              specifications: skuItem.id,
              goodsId: skuItem.goodsId,
              name: goods.goodsName,
            },
          ],
        },
      ];
      var list = [];

      var item = {
        // 商品id
        id: skuItem.id,
        s1: "1",

        // 规格id(同上)
        // skuId: skuItem.id,
        // 价格(元为单位)
        skuPrice: skuItem.skuPrice,
        // 商品图片
        // memberIcon: skuItem.memberIcon,
        // price:价格（分为单位） vant-sku中以分为单位，回自动除以100
        price:
          skuItem.indicativePrice || skuItem.indicativePrice == 0
            ? skuItem.indicativePrice * 100
            : skuItem.skuPrice * 100,
        stock_num: skuItem.skuStock,
        desc: skuItem.skuDesc,
      };
      if (skuItem.isExamine == 0 || skuItem.isExamine == 1) {
        // 自定义字段，当前规格是否需要审核（会议有审核字段）
        item.isExamine = skuItem.isExamine;
      }
      list.push(item);
      goodsObj.sku.list = list;

      if (item.stock_num != 0) {
        goodsObj.initialSku = {
          s1: list[0].s1,
          s2: 0,

          selectedNum: 1,
        };
      } else {
        goodsObj.initialSku = {
          s1: "0",
          s2: "0",
          selectedNum: 0,
        };
      }
    }
    if (
      goods.albumPics.split(",")[0] &&
      goods.albumPics.split(",")[0] != "null"
    ) {
      goodsObj.goods.picture = global.imgUrl + goods.albumPics.split(",")[0];
    } else {
      goodsObj.goods.picture = "";
    }

    return goodsObj;
  },

  equals(data, data2) {
    function getType(obj, str = null) {
      const typeStr = Object.prototype.toString.call(obj).split(" ")[1];
      const type = typeStr
        .substring(0, typeStr.length - 1)
        .trim()
        .toLowerCase();
      if (
        type === "object" &&
        Object.prototype.toString.call(obj).toLowerCase() ===
          "[object object]" &&
        !obj.length
      ) {
        return str ? "json" === str : "json";
      }
      return str ? type === str : type;
    }

    function compare(obj1, obj2) {
      const obj1Type = getType(obj1);
      const obj2Type = getType(obj2);
      // 判断类型是否一致
      if (obj1Type !== obj2Type) {
        return false;
      }

      // 判断内容是否一致
      if (
        ["string", "number", "boolean", "null", "undefined"].includes(
          obj1Type
        ) &&
        obj1 !== obj2
      ) {
        return false;
      }

      // 对象判断
      if (["json", "object"].includes(obj1Type) || Array.isArray(obj1)) {
        const obj1Keys = Object.keys(obj1);
        const obj2Keys = Object.keys(obj2);
        // 判断字段数量是否一致
        if (obj1Keys.length !== obj2Keys.length) {
          return false;
        }

        const bool = obj1Keys
          .map((key) => obj2Keys.includes(key))
          .every((b) => b);
        // 判断每一个字段都是一致
        if (!bool) {
          return false;
        }

        for (let i = 0; i < obj1Keys.length; i++) {
          const key = obj1Keys[i];
          const bool = compare(obj1[key], obj2[key]);
          if (!bool) {
            return false;
          }
        }
      }

      // 函数判断
      if (["function", "asyncfunction"].includes(obj1Type)) {
        return obj1.toString() === obj2Keys.toString();
      }

      return true;
    }

    return compare(data, data2);
  },
  // 摘要富文本去除格式
  formatArtSumary(val) {
    if (val) {
      val = val.replace(/<\/?p[^>]*>/gi, "");
      val = val.replace(/<\/?strong[^>]*>/gi, "");
      val = val.replace(/<\/?em[^>]*>/gi, "");
      val = val.replace(/<\/?div[^>]*>/gi, "");
      val = val.replace(/<\/?span[^>]*>/gi, "");
      val = val.replace(/<\/?img[^>]*>/gi, "");
      val = val.replace(/<\/?video[^>]*>/gi, "");
      return val;
    } else {
      return val;
    }
  },
};

// 注册插件全局通用
export default {
  install() {
    Vue.prototype.$global = global;
  },
  global,
};
